import { createReducer } from 'typesafe-actions';

import {
  TBulkCardCreationsAction,
  BulkCardCreationsActionTypes,
  IBulkCardCreationsState,
} from '@/features/cards/store/types/bulk-cards-creation.types';

const initialState: IBulkCardCreationsState = {
  bulkCardCreations: [],
  bulkCardCreationDraft: null,
  currentStep: 0,
  latestStep: 0,
  isLoading: false,
};

export const bulkCardCreationReducer = createReducer<IBulkCardCreationsState, TBulkCardCreationsAction>(initialState)
  .handleType(BulkCardCreationsActionTypes.GET_BULK_CARD_CREATIONS, (state) => ({
    ...state,
    isLoading: true,
    error: state.latestStep ? state.error : undefined,
  }))

  .handleType(BulkCardCreationsActionTypes.GET_BULK_CARD_CREATIONS_SUCCESS, (state, action) => ({
    ...state,
    bulkCardCreations: action.bulkCardCreations,
    isLoading: false,
    error: undefined,
  }))

  .handleType(BulkCardCreationsActionTypes.GET_BULK_CARD_CREATIONS_FAIL, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error,
  }))

  .handleType(BulkCardCreationsActionTypes.CREATE_BULK_CARD, (state) => ({
    ...state,
    isLoading: true,
    error: state.latestStep ? state.error : undefined,
  }))

  .handleType(BulkCardCreationsActionTypes.CREATE_BULK_CARD_SUCCESS, (state, action) => ({
    ...state,
    bulkCardCreations: [...state.bulkCardCreations, action.bulkCard],
    isLoading: false,
    error: undefined,
  }))

  .handleType(BulkCardCreationsActionTypes.CREATE_BULK_CARD_FAIL, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error,
  }))

  .handleType(BulkCardCreationsActionTypes.SET_STEP, (state, action) => {
    return {
      ...state,
      currentStep: action.currentStep,
      latestStep: action.currentStep > state.latestStep ? action.currentStep : state.latestStep,
      bulkCardCreationDraft: { ...state.bulkCardCreationDraft, ...action.bulkCardCreationDraft, designType: 'virtual' },
    };
  })

  .handleType(BulkCardCreationsActionTypes.CLEAR_BULK_CARD_CREATION_CACHE, () => ({
    ...initialState,
  }));
